module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppConnecte_Silver.be0fc255.svg";